export enum CashlessStatus {
    ACTIVE = 1,
    INACTIVE = 0,
    REFUNDED_REQUESTED= 2,
    REFUNDED = 3,
    CANCELLED = 4,
}